import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ClonerService } from '../helper/cloner.service';
import {
  ICompaniesShortList,
  ICompanyDetail,
  ICompanyExportDetail,
  ICompanySearchCriteria,
  ILotDisableSpace,
} from 'src/app/shared/interfaces';
import { FormGroup } from '@angular/forms';

@Injectable()
export class CompanyStateService {
  public queryCriteriaForm: FormGroup;
  //public currentLotNumber: string = ''; MARKED FOR DELETION 20241114 :: Ken Moss
  public companyFullList: ICompanyDetail[] = [];
  public companyFilteredList: ICompanyDetail[] = [];
  public companyExportList: ICompanyExportDetail[] = [];
  public companyDetail: ICompanyDetail;
  public companyFormGroup: FormGroup;
  public modeAddNew: boolean = false;
  public companyList: ICompanySearchCriteria[] = [];
  public selectedCompanyList: ICompanySearchCriteria[];
  public spaceDisableLotList: ILotDisableSpace[] = [];

  public InitCompanyState(): void {
    this.queryCriteriaForm = undefined;
    //this.currentLotNumber = ''; MARKED FOR DELETION 20241114 :: Ken Moss
    this.companyFullList = [];
    this.companyFilteredList = [];
    this.companyExportList = [];
    this.companyDetail = undefined;
    this.companyFormGroup = undefined;
    this.modeAddNew = false;
    this.companyList = [];
    this.selectedCompanyList = [];
  }

  public SetEndDateOnCompanyLists(companyId: string, endDate: Date): void {
    let ii: number = 0;

    for (ii = 0; ii < this.companyFullList.length; ii++) {
      if (this.companyFullList[ii].companyId == companyId) {
        this.companyFullList[ii].endDate;
      }
    }
  }

  GetSpaceDisableSetting(currentLotNumber: string): boolean {
    let spaceDisableSetting: boolean = false;
    let ii: number;

    for (ii = 0; ii < this.spaceDisableLotList.length; ii++) {
      if (currentLotNumber == this.spaceDisableLotList[ii].lotNumber) {
        spaceDisableSetting = true;
        break;
      }
    }

    return spaceDisableSetting;
  }
}
